import * as THREE from 'three';

import AbstractObject from '../misc/object';

export default class Arrow extends AbstractObject {

  static types = {
    direction: {
      X: 'x',
      Y: 'y',
      Z: 'z',
      NegativeX: '-x',
      NegativeY: '-y',
      NegativeZ: '-z'
    }
  };

  constructor(options) {
    super(options);
    this.arrowSize = this.options.arrowSize || 10;
    this.direction = this.options.direction;
    this.color = this.options.color || 0x000000;
    this.isSingle = this.options.isSingle || false;

    const { position } = this.options;

    if (!position) throw new Error('Position is a required property!');

    this.object.addMesh(this.getArrow(position, this.size));

    if (!this.isSingle) {
      let secondArrowPos = this.endPosition.clone();
      switch (this.direction) {
        case Arrow.types.direction.Y: {
          this.object.addMesh(this.getArrow(secondArrowPos, -this.size));
          break;
        }
        case Arrow.types.direction.NegativeY: {
          this.object.addMesh(this.getArrow(secondArrowPos, -this.size));
          break;
        }
        case Arrow.types.direction.Z: {
          this.object.addMesh(this.getArrow(secondArrowPos, -this.size));
          break;
        }
        case Arrow.types.direction.NegativeZ: {
          this.object.addMesh(this.getArrow(secondArrowPos, -this.size));
          break;
        }
        case Arrow.types.direction.NegativeX: {
          this.object.addMesh(this.getArrow(secondArrowPos, -this.size));
          break;
        }
        default: {
          this.object.addMesh(this.getArrow(secondArrowPos, -this.size));
          break;
        }
      }
      //VladP: switch back to the initial endPosition, otherwise it will represent the start position
      this.endPosition = secondArrowPos.clone(); 
    }
  }

  get size() {
    return this.options.size;
  }

  get position() {
    return this.options.position;
  }

  getArrow(position, size) {
    var from = position;

    let to = null;
    switch (this.direction) {
      case Arrow.types.direction.Y: {
        to = new THREE.Vector3(position.x, position.y + size, position.z);
        break;
      }
      case Arrow.types.direction.NegativeY: {
        to = new THREE.Vector3(position.x, position.y - size, position.z);
        break;
      }
      case Arrow.types.direction.Z: {
        to = new THREE.Vector3(position.x, position.y, position.z + size);
        break;
      }
      case Arrow.types.direction.NegativeZ: {
        to = new THREE.Vector3(position.x, position.y, position.z - size);
        break;
      }
      case Arrow.types.direction.NegativeX: {
        to = new THREE.Vector3(position.x - size, position.y, position.z);
        break;
      }
      default: {
        to = new THREE.Vector3(position.x + size, position.y, position.z);
        break;
      }
    }

    this.endPosition = to;

    const direction = to.clone().sub(from);
    var length = direction.length();

    if (this.arrowSize >= length) {
      // from is not always a Vector3
      let offSet = direction.clone().normalize().negate().multiplyScalar(this.arrowSize - length);
      from.x += offSet.x;
      from.y += offSet.y;
      from.z += offSet.z;
      length = this.arrowSize + 1;
    }
    const arrow = new THREE.ArrowHelper(direction.normalize(), from, length, this.color, this.arrowSize, this.arrowSize / 2);

    if (this.options.disableDepthTest) {
      arrow.frustumCulled = false;
      Array.prototype.forEach.call(arrow.children, (item) => {
        item.material.depthTest = false;
        item.material.depthWrite = false;
        item.frustumCulled = false;
      });
    }

    return arrow;
  }

}



// WEBPACK FOOTER //
// ./src/object-view/objects/arrow.js